<template>
  <div id="Header" :class="isLightTheme ? 'header-container-light' : 'header-container'">
    <div v-if="!isLightTheme && topOfPageLinks" class="help-bar">
      <a
        v-for="(item, key) in topOfPageLinks.links"
        :key="key"
        :href="item.url"
        :target="topOfPageLinks.opensInNewTab ? '_blank' : '_self'"
        class="help-bar-link"
      >
        {{ item.label }}
      </a>
    </div>
    <header
      class="header"
      :class="isLightTheme ? 'header-light' : 'bg-brand-highlight-3'"
    >
      <button
        v-if="!isLightTheme && windowWidth <= 767 && headerMenuLinks"
        @click="toggleHeaderMenu"
        class="header-menu-btn"
      >
        <i v-if="isHeaderMenuShown" class="header-menu-close fa-solid fa-xmark"></i>
        <img
          v-else
          src="/img/header/header-menu.png"
          alt="Burger-menu icon"
          class="header-menu-icon"
        />
      </button>
      <button class="logo-button" @click="$router.push('/')">
        <img
          class="header-logo"
          :src="
            isLightTheme
              ? '/img/header/sh-logo-light-theme.png'
              : '/img/dmh/sh-logo.svg'
          "
          alt="Spectrum.Life logo"
          onerror="this.src='/img/logo-spectrum-life.svg'"
        />
      </button>
      <button v-show="isLightTheme" @click="$router.push('/')" class="close-button">
        <i class="fa-regular fa-times fa-2x clickable"></i>
      </button>
      <UserInfoMenu v-show="!isLightTheme" />
    </header>
    <ul
      v-if="
        !isLightTheme &&
          (windowWidth > 767 || isHeaderMenuShown) &&
          headerMenuLinks
      "
      class="header-menu"
    >
      <li
        v-for="(item, key) in headerMenuLinks.links"
        :key="key"
        class="header-menu-item"
      >
        <span v-if="item.label.toLowerCase() === 'my health'" class="header-menu-link active">{{ item.label }}</span>
        <a
          v-else
          class="header-menu-link"
          :href="item.url"
          :target="headerMenuLinks.opensInNewTab ? '_blank' : '_self'"
        >
          {{ item.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import UserInfoMenu from "./MyHealth/UserInfoMenu.vue";
import { mapState } from "vuex";

export default {
  name: "Header",
  components: {
    UserInfoMenu
  },
  props: {
    isLightTheme: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHeaderMenuShown: false,
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapState(["navigationTags"]),
    topOfPageLinks() {
      return this.navigationTags?.topOfPage || null;
    },
    headerMenuLinks() {
      return this.navigationTags?.topNav || null;
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    toggleHeaderMenu() {
      this.isHeaderMenuShown = !this.isHeaderMenuShown;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="less">
#Header {
  &.header-container{
    width: 100%;
    max-width: 1170px;
    margin: 0 auto;
  }

  &.header-container-light{
    border-bottom: 1px solid #aeb0bd;
  }

  .logo-button {
    background: none;
    border: none;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none outside none;
  }

  .help-bar {
    background-color: #0F152E;
    display: flex;
    justify-content: flex-end;
    padding: 10px 16px;
    gap: 12px;
  }

  .help-bar-link {
    color: #fff;
    font-size: 1.4rem;
    line-height: 2rem;
    margin: 0;
    font-family: "PlusJakartaSansRegular";
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .header {
    display: flex;
    min-height: 64px;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    border-bottom-right-radius: 24px;
    border-bottom-left-radius: 24px;
    box-shadow: 0px 4px 4px 0px #00000026;
    padding: 16px 48px;
  }

  .header-menu {
    display: flex;
    gap: 16px;
    border-bottom: 1px solid #b1bde7;
    padding: 24px 24px 0;
  }

  .header-menu-item {
    font-family: "PlusJakartaSansRegular";

    .header-menu-link {
      display: block;
      position: relative;
      color: #192550;
      line-height: 2.4rem;
      font-size: 2rem;
      padding: 16px 10px;

      &:hover {
        color: #192550;
      }

      &.active,
      &:active {
        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 4px;
          background-color: #192550;
        }
      }
    }
  }

  .header-menu-btn {
    width: 40px;
    border: none;
    background: none;
  }

  .header-menu-icon {
    cursor: pointer;
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .header-menu-close {
    color: #fff;
    font-size: 4rem;
  }

  .header-light {
    border-radius: unset;
    padding: 32px 28px;
    box-shadow: none;
    width: 100%;
    max-width: 1170px;
    margin: 0 auto;
  }

  .header-logo {
    cursor: pointer;
    height: 64px;
    width: 262px;
    object-fit: contain;
  }

  .close-button {
    background-color: rgba(25, 37, 80, 0.05);
    border: 1.5px solid transparent;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    padding: 14px 16px;

    &:hover, &:focus {
      border: 1.5px solid #192550;
    }
  }
}

@media screen and (max-width: 767px) {
  #Header {
    .header-logo {
      height: 42px;
      width: 140px;
    }

    .header {
      padding: 16px 28px 16px 24px;
    }

    .header-menu {
      flex-direction: column;
      gap: 0;
      box-shadow: 0px 4px 16px 0px #00000040;
      border-bottom: none;
      padding: 0;
      margin: 12px 12px 20px;
    }

    .header-menu-item {
      border-bottom: 1px solid #e0e0e0;

      .header-menu-link {
        color: #000000;
        line-height: 1.8rem;
        font-size: 1.4rem;
        padding: 10px;

        &:hover {
          background-color: #f2f4f8;
          color: #000000;
        }

        &.active,
        &:active {
          text-decoration: underline;
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
